import React, { useEffect,useState } from "react";
import { connect, useSelector, useDispatch } from "react-redux";
import withRipple from "jd-library/withRipple";
import styles from "./image-upload.scss";
import viewImageStyle from '../ViewImage/viewImage.scss';
import FileSelector from "../FileSelector";
import Image from "../Image/ImageLazyWrapper";
import { useHistory } from 'react-router-dom';
import {checkLoggedIn} from "../../utills";
import {
	getImagePath,
	onFileSelUpload
} from "../productImageUtils";
import { openGallery, onImageUploadFromAppSuccess } from '../Utills';
import {
	updateProductMedia,
	toggleEditImageOptions,
	getProductData
} from "../../actions/products";
import {
	toggleUploadOptions
} from '../../actions/upload-options';
import {
	toggleLibrarySlider
} from "../../actions/videoLibrary";
import EditImageButton from "../Image/EditImageButton";
import ThumbnailProgressBar from "../Video/ThumbnailProgressBar";
import VideoPlayerWrapper from "../Video/VideoPlayerWrapper";
import { thumbnailDomain } from '../../../config/config-video';
import AuthWrapper from '../AuthWrapper';
import useTouchAndHold from 'jd-library/useTouchAndHold'
import { NO_IMAGE, NO_IMAGE_WITH_CAPTION } from "jd-library/src/constants/ImageIcons";
import UblcsModal from "../Ublcs-modal";

export const AddVideoDiv = (props) => {
	return (
		<ImageViewUpload
			{...props}
			forVideo
			imageListIndex={props.imageUrlArr.length + 1}
		/>
	)
}

const UploadImage = props => {

	const showAddEditProduct = useSelector(state => state.products && state.products.showAddEditProduct);
	const showEnrichEditProduct = useSelector(state => state.products && state.products.showEnrichEditProduct);
	const isMobile = useSelector(state => state.library.deviceData.isMobile);
	const [ublcsModal, toggleUblcsModal] = useState(false);
    const dispatch = useDispatch();
	const fileSelector = React.useRef(null);
	let history = useHistory();
	const checkForOptions = (e) => {
		if(props.customOnClick) {
			props.customOnClick();
			return;
		}
		if (props.variantStatus) {
			props.toggleNoEditModal(true);
			return;
		}
		if (props.showOptions) {
			props.openImageOptions();
		} else {
			if(props.onAddClickCB){
				props.onAddClickCB();
			}
			if (!(window.jdInterface && !window.jdInterface.isIOSApp && !window.jdInterface.openNativeFileChooser)) {
				if (props.session.source === 'b2b' || props.session.source === 'webstore') {
					if (props.session.isReadOnly) {
						return;
					}
					if (((props.tabKey == 'auditPending' && props.id) || props.reviewStatus == 'APPROVAL_PENDING' || props.reviewStatus == 'DELETION_PENDING') && props.redirectToEdit && props.session.user.loggedUser && props.session.user.loggedUser.userType == 'OWNER') {
						props.redirectToEdit();
					}
					else {
						props.toggleUploadOptions({
							show: true,
							type: props.forVideo ? 'video' : 'image',
							data: {
								productId: props.productId,
								ignoreSave: props.ignoreSave,
								imageUrlArr: props.noPrimaryImage ? [] : props.imageUrlArr,
								categoryType: props.categoryType,
								isDummyProductRow: props.isDummyProductRow
							},
							style: {
								position: 'absolute',
								left: e.clientX,
								top: e.clientY - document.body.getBoundingClientRect().top
							},
							containerInfo: {
								element: props.popoverTarget ? props.popoverTarget : e.currentTarget,
								pos: props.pos || 'bottom',
								customClass: props.popoverClass || ''
							},
							keywordId: props.keywordId,
							updateError: props.updateError,
							...props.uploadOptionProps
						});
					}
				} else {
					fileSelector.current.triggerClick(true);
				}
			} else {
				if (props.session.source === 'webstore') {
					props.toggleUploadOptions({
						show: true,
						type: props.forVideo ? 'video' : 'image',
						data: {
							variantId: props.variantId,
							ignoreSave: props.ignoreSave,
							imageUrlArr: props.noPrimaryImage ? [] : props.imageUrlArr
						},
						isAndroidApp: true
					});
				} else {
					let onImageUploadFromAppCB = function (res) {
						onImageUploadFromAppSuccess(res, props, props.variantId, props.onChange);
					};
					openGallery({ index: 0, callback: onImageUploadFromAppCB });
				}
			}
			//fileSelector.current.triggerClick(true); //Add-Edit-Product
		}
	}
	const onChange = (e) => {
		props.onFileSelUpload ? props.onFileSelUpload(e, props) : onFileSelUpload(e, props);
		props.onChange && props.onChange();
		const isAddProductPage = showAddEditProduct;
		const isEnrichProductPage = showEnrichEditProduct
		if ((!isAddProductPage && !isEnrichProductPage) && props.variantId == 'ADD_PRODUCT') {
			if(isMobile){
				history.push("/products/add")
			}else{
				dispatch(getProductData({}));
			}

		}
	}

	const ublcsModalHandler = () => {
		toggleUblcsModal(true);
	};

	const iconClass = props.forVideo ? 'icon-videoCam' : 'icon-cameraNew';
	const showAddImageWithText = props.showAddImageWithText;
	const handleUploadActivate = event => {
		event.stopPropagation();
		if (props?.session?.isReadOnly) {
			ublcsModalHandler();
			return;
		}
		if (!props?.disableFileSelector) {
			checkForOptions(event);
		}
		if (props?.shouldRedirectToEditInsteadOfOption) {
			if (props.customCB) {
				props.customCB();
				return;
			}
			if (props.redirectToEdit) {
				props.redirectToEdit();
				return;
			}
		}
	};
	return (
		<>
			<div
				className={`${styles['no-img']} ${props.showColourLoaderIfEmpty ? ' no-dash ' : ''} ${props.rippleClass} ${props.showError ? styles['error-div'] : ''}`}
				{...props.rippleHandler}
				onClick={handleUploadActivate}
				tabIndex={0}
				role="button"
				aria-label={props.forVideo ? 'Add Video' : 'Add Image'}
				onKeyDown={e => { if (e.key === 'Enter' || e.key === ' ') { e.stopPropagation(); e.preventDefault(); handleUploadActivate(e); } }}
			>
				{!showAddImageWithText ? (
					<span className={`${iconClass} ${styles['camera-icon']}`} />
				) : (props.showColourLoaderIfEmpty ? <NoImageForTemplate /> :
					(<div>
						<span className={`${iconClass} ${styles['camera-icon']} font-26`} />
						<div className={styles['upload-text']}>
							{
								props?.uploadLabel?
								props?.uploadLabel 
								: props.forVideo ? 'Add Video' : 'Add Image'
							}
						</div>
					</div>)
					)}
				{props.renderRipple && props.renderRipple()}
			</div>
			<FileSelector
				onChange={onChange}
				ref={fileSelector}
				forVideo={props.forVideo}
			/>
			{ublcsModal && (
			<UblcsModal
				onHidden={() => toggleUblcsModal(false)}
			/>
			)}
		</>
	);
};

const mapStateToProps = (state, props) => {
	return {
		session: state.session,
		...props
	};
};

const NoImageWrapper = connect(mapStateToProps, { updateProductMedia, toggleLibrarySlider, toggleUploadOptions })(
	withRipple(UploadImage)
);
const NoImageForTemplate = (props) => {
	const imageProps = {
		style: {
			borderRadius: '10px'
		},
		imgClass: styles['no-img-image'],
		finalImageSrc: props.smallImage?NO_IMAGE:NO_IMAGE_WITH_CAPTION,
		retainRandomColor: true,
	}
	return (
		<div className="no-img template-product" onClick={() => {
			props.onClick && props.onClick()
		}}>
			<Image {...imageProps} />
		</div>
	);
};
const ImageViewUpload = props => {
	let imgSrc = '';
	if (props?.baseURL) {
		imgSrc = props.baseURL;
	} else {
		imgSrc = (props.imageUrl || "").split(",");
	}
	const isTemplateProduct = props.isTemplate || props.isTempProd;
	const isAuditor = props.isAuditor;
	const isReadOnly = props.isReadOnly;
	const imgIndex = props.imageListIndex || 0;
	const isImageList = !!props.imageListIndex || props.isImageList;
	const history = useHistory();
	let imageProps = {};
	let tempImgSrc = '';
	if (props.imageUrlArr) {
		imageProps = {
			...props.imageUrlArr[imgIndex]
		};
	} else if (imgSrc[imgIndex]) {
		tempImgSrc = imgSrc[imgIndex];
		if (props?.baseURL) {
			tempImgSrc = imgSrc;
		}
		imageProps = {
			uploaded: true,
			actualPath: getImagePath(tempImgSrc,isTemplateProduct)
		};
	}
	if (imageProps.isVideo && imageProps.source != 'YOUTUBE') {
		imageProps.actualPath = `${thumbnailDomain}${imageProps.thumbnailURL}`;
	}
	const checkCB = (e) => {
		e.stopPropagation();
		props.checkCB && props.checkCB();
	}
	const openImageUploadOption = event => {
		checkLoggedIn({
			cb:()=>{
				 
				if(props.customCB){
					props.customCB();
					return;
				}
				if (props.onlyForSelection){
					props.redirectToEdit && props.redirectToEdit();
					return;
				}
				let newImgIndex = imgIndex; //handling because of not displaying video as primary
				if (props.noPrimaryImage) {
					newImgIndex = 0;
				}
				if (props.isBrandedProd || props.isObjectionable || (props.tabKey == 'auditPending' && props.id) || props.session.isReadOnly || props.isGalleryProd || ((props.reviewStatus == 'APPROVAL_PENDING' || props.reviewStatus == 'DELETION_PENDING') && props.redirectToEdit && props.session.user.loggedUser && props.session.user.loggedUser.userType == 'OWNER')) {
					if (newImgIndex == 2 && typeof props.isExpanded !== 'undefined' && !props.isExpanded) {
						props.animateExpOnClick(true);
					}
					else {
						props.redirectToEdit();
					}
				}
				else if (typeof props.isExpanded !== 'undefined' && !props.isExpanded && props.remainingImages) {
					props.animateExpOnClick(true);
				} else {
					props.onImageClick && props.onImageClick(true, props.productId, newImgIndex, isTemplateProduct, props.variantStatus, props.productData);
				}
			},
			history
		})

	};
	let childrenMarkup;

	if (imageProps.isVideo) {
		//show progress bar thumbnail progress
		childrenMarkup = !imageProps.uploaded ? (
			<ThumbnailProgressBar
				videoKey={imageProps.imgIndex}
				onClick={openImageUploadOption}
			/>
		) : (
				<VideoPlayerWrapper
					{...imageProps}
					onClick={openImageUploadOption}
					showThumbnail
					showStatus
				/>
			)
	} else {
		childrenMarkup = (
			(imageProps.base64Url || imageProps.actualPath) && !props.isAddVariant ? (
				<ImageWithRipple
					openImageUploadOption={openImageUploadOption}
					isTemplateProduct={isTemplateProduct}
					imageProps={imageProps}
					remainingImages={props.remainingImages}
				/>
			) : (isTemplateProduct || isAuditor || isReadOnly) ? ((props.imageUrl == "" || !props.imageUrl) ? (
				<NoImageForTemplate smallImage={props.smallImage} onClick={isReadOnly ? props.redirectToEdit : null} />
			) : '') : (
						<AuthWrapper>
							<NoImageWrapper
								variantId={props.variantId}
								showToastMessage={props.showToastMessage}
								imageUrlArr={props.imageUrlArr}
								isImageList={isImageList}
								onFileSelUpload={props.onFileSelUpload}
								{...props}
							/>
						</AuthWrapper>
					)
		)

	}
	const longPressHandler = props.onLongPress ? useTouchAndHold({
        duration: 500,
        deps: [props.tickStatus],
        onTouchHold: e => {
			e.stopPropagation();
			console.log("Longpress")
			props.onLongPress();
        }
    }) : null;
	return (
		<div className={`${styles["img-holder"]} ${styles[props.className]} ${props.className} ${props.isAddImageDiv ? viewImageStyle['add-image-div'] : ''}`} onClick={e => e.stopPropagation()} onMouseDown={e => e.stopPropagation()} style={props.style} {...longPressHandler}>
			<div className={styles["img-rounded"]}>
				{childrenMarkup}

				{/* Add-Edit-Product */}
				{/* {imageProps.base64Url || imageProps.actualPath ? (
					<ImageWithRipple
						openImageUploadOption={openImageUploadOption}
						isTemplateProduct={isTemplateProduct}
						imageProps={imageProps}
						remainingImages={props.remainingImages}
					/>
				) : isTemplateProduct ? (
					<NoImageForTemplate />
				) : (
					<NoImageWrapper
						variantId={props.variantId}
						showToastMessage={props.showToastMessage}
						imageUrlArr={props.imageUrlArr}
						isImageList={isImageList}
						{...props}
					/>
				)} */}
			</div>
			{false && !isTemplateProduct && !isImageList && (imageProps.base64Url || imageProps.actualPath) && <EditImageButton
				onClick={openImageUploadOption}
			/>}
			{props.showCheckBox &&
				<>
					<div
						className='multi-select-checkbox-clickarea'
						role="checkbox"
						aria-checked={!!props.tickStatus}
						aria-label="Select product"
						tabIndex={0}
						onClick={(e) => { checkLoggedIn({ cb: () => { checkCB(e); }, history }); }}
						onKeyDown={e => { if (e.key === 'Enter' || e.key === ' ') { e.stopPropagation(); e.preventDefault(); checkLoggedIn({ cb: () => { checkCB(e); }, history }); } }}
					>
						<div className={`multi-select-checkbox ${props.tickStatus ? 'no-border' : ''}`}>
							{props.tickStatus && <i className='icon-Checkmark'></i>}
						</div>
					</div>
					{/* {props.tickStatus && <div className='check-tint'></div>} */}
				</>
			}
		</div>
	);
};

export default connect(null, {
	toggleEditImageOptions
})(ImageViewUpload);

const ImageWithRipple = withRipple(props => {
	const {
		openImageUploadOption,
		isTemplateProduct,
		imageProps
	} = props;
	let imgMarkup = null;
	if (imageProps.isVideo && imageProps.thumbnailURL) {
		imgMarkup = null;
		//reder thumbanil image here
		imgMarkup = <Image
			actualPath={imageProps.source == 'YOUTUBE' ? imageProps.thumbnailURL : `${thumbnailDomain}${imageProps.thumbnailURL}`}
			uploaded={true}
			loadOrignal={true}
		/>
	} else {
		imgMarkup = <Image {...imageProps} />
	}
	return (
		<>
			<div onClick={openImageUploadOption} className={`${props.rippleClass} ${styles['img-ripple-wrapper']}`} {...props.rippleHandler}>
				{imgMarkup}
				{props.renderRipple()}
				{!!props.remainingImages && <div className='remaining-images font-16'>
					+{`${props.remainingImages}`}
				</div>}
			</div>
		</>
	)
})
